import errorCode from '../../utils/errorCode.json';
import COUNTRY_CODE_LIST from './countryCodeList.json';

const json = {
  noPrefix: {}, // for notice no prefix set when use zustand translate prefix
  errorCode: errorCode.en,
  countryCodes: COUNTRY_CODE_LIST, // Reference: https://github.com/joonhocho/country-calling-code

  menu: {
    version: 'Version',
    homepage: 'Home Page',
    setting: 'Setting',
    accountSetting: 'Account Setting',
    changePassword: 'Change Password',
    userSetting: 'User Setting',
    request: 'Request',
    balance: 'Balance',
    report: 'Report',
    toggleFilterButtonCollapse: 'Collapse',
    toggleFilterButtonExpand: 'Expand',
    toggleBtnCollapse: 'Collapse',
    toggleBtnExpand: 'Expand',

    transactionRequest: 'Transaction Request',
  },

  common: {
    welcome: 'Welcome',
    tokenNotFound: 'Token not found',
    logout: 'Log out',
    confirm: 'Confirm',
    edit: 'Edit',
    filter: 'Filter',
    cancel: 'Cancel',
    start_date: 'Start Date',
    end_date: 'End Date',
    no_data_export: 'No data for export',
    phSelection: 'Please select {{fieldName}}',
    phInputField: 'Please enter {{fieldName}}',
    input_field_check_number: 'Please enter valid {{fieldName}}',
    phSelectionOptional: 'Please select {{fieldName}} (Optional)',
    phInputFieldOptional: 'Please enter {{fieldName}} (Optional)',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    table: 'Table',
    successCreate: 'Created {{target} Successfully',
    autoLogoutAlert:
      'Automatically logged out because another account is already logged in from same browser',
    logoutAlert: 'You have been logged out',
    alert_no_permission: 'No relevant permission',
    programName: 'Program Name',
    question_type: 'Question Type',
    idv_method: 'IDV Method',
    customerId: 'Customer Id',
    status: 'Status',
    customerNumber: 'Customer Number',
    merchantId: 'Merchant Id',
    createdBy: 'Created By',
    creationDate: 'Created Date',
    lastModifiedBy: 'Last Modified By',
    lastModifiedTime: 'Last Modified Time',
    lastModifiedDate: 'Last Modified Date',
    latestVersion: 'Latest Version',
    applicationNumber: 'Application Number',
    txHash: 'Transaction Hash',
    referenceNumber: 'Reference Number',
    currency: 'Currency',
    approvalProgressDialogTitle: 'Approval Progress',
    no_relevant_permission: 'No relevant permission',
    no_same_operator_creator: 'Operator and creator cannot be the same',
    no_same_approver: 'Approver and operator cannot be the same',
    request_approved: 'Request Approved',
    approve_successful: 'Approve Successful',
    request_rejected: 'Request Rejected',
    remarks: 'Remarks',
    confirm_btn: 'Confirm',
    approve_btn: 'Approve',
    reject_btn: 'Reject',
    approve_reject_request_btn: 'Approve/Reject',
    viewDetail: 'View Detail',
    approve_reject_dialog_title: 'Approve/Reject ',
    chainName: 'Chain Name',
    selectSearchLabel: 'Type to search',
    orderId: 'Order Id',
    transactionType: 'Transaction Type',
    amount: 'Amount',
    sendingAddress: 'Sending Address',
    receivingAddress: 'Receiving Address',
    creditAmount: 'Credit Amount',
    exchangeRate: 'Exchange Rate',
    transactionHash: 'Transaction Hash',
    creationTime: 'Creation Time',
    cancel_btn: 'Cancel',
    approveReject: 'Approve/Reject',
    applicationDetails: 'Application Details',
    close: 'Close',
    no_data_found: 'No Data in Database',
    auto: 'Auto',
    create_request: 'Create Request',
    not_allow_to_pick: 'Not allow to pick {{object}',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    create_request_success: 'Created request successfully',
    create_record_success: 'Created record successfully',
    copied: 'Copied!',
    clientId: 'Client Id',
    create_record: 'Create Record',
    adjustmentAmount: 'Adjustment Amount',
    createRecord: 'Create Record',
    validate_below_zero: '{{fieldName}} must be larger than 0',
    validate_zero: '{{fieldName}} must not be 0',
    no_changes_made_warning: 'Please modify',
    homeCurrency: 'Home Currency',
    successful_edit: 'Edited successfully',
    rewardRate: 'Reward Rate',
    editRecord: 'Edit Record',
    edit_btn: 'Edit',
    request_record_created: 'Request record created',
    network: 'Network',
    yes: 'Yes',
    no: 'No',
    next: 'next',
    optional_field: '{{fieldName} (Optional)',
    fromCurrency: 'From Currency',
    toCurrency: 'To Currency',
    agentLoginEmail: 'Login Email',
    roles: 'Roles',
    noRecord: 'No Record',
    month: 'Month',
    transactionAmount: 'Transaction Amount',
    cannot_exceed_warning: '{{fieldName} cannot exceed {{value}}',

    taskId: 'Task ID',
    to: 'To',
    from: 'From',
    download: 'Download',
    am: 'AM',
    pm: 'PM',
    enterYubiKey: 'Enter YubiKey',
    yubiKey_required: 'YubiKey is required',
    operationType: 'Operation Type',
    view: 'View',
  },

  enumConstants: {
    en: 'English',
    zh_cn: '繁中',
    timezone0: '+0',
    timezone1: '+1',
    timezone2: '+2',
    timezone3: '+3',
    timezone4: '+4',
    timezone5: '+5',
    timezone6: '+6',
    timezone7: '+7',
    timezone8: '+8',
    timezone9: '+9',
    timezone10: '+10',
    timezone11: '+11',
    timezone12: '+12',
    timezone13: '-11',
    timezone14: '-10',
    timezone15: '-9',
    timezone16: '-8',
    timezone17: '-7',
    timezone18: '-6',
    timezone19: '-5',
    timezone20: '-4',
    timezone21: '-3',
    timezone22: '-2',
    timezone23: '-1',
    yes: 'Yes',
    no: 'No',

    // Wallet Transaction Types
    Desposit: 'Deposit',
    Withdraw: 'Withdrawal',
    Transfer: 'Transfer',
    Exchange: 'Exchange',
    Fee: 'Fee',
    Refund: 'Refund',
    Swap: 'Swap',
    Payment: 'Payment',
    FiatWithdraw: 'Fiat Withdrawal',
    BuyWithCard: 'Buy with Card',
    MerchantDeposit: 'Merchant Deposit',

    // Wallet Transaction Request Status Types
    Pending: 'Pending',
    Processing: 'Processing',
    Completed: 'Completed',
    Success: 'Success',
    Failed: 'Failed',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected',
    Approved: 'Approved',
    Executing: 'Executing',
    ExecutedSuccess: 'Executed Successfully',
    ExecutedSuccessfully: 'Executed Successfully',
    ExecutedFailed: 'Execution Failed',
    AwaitRiskLevel: 'Awaiting Risk Assessment',
    Execute: 'Execute',
    Inital: 'Initial',
    RefundedSuccess: 'Refunded Successfully',

    // Wallet Direction Types
    In: 'In',
    Out: 'Out',

    // Request Types (some may be duplicated below in Wallet Transaction Types)
    CrossMerchantTransfer: 'Cross Merchant Transfer',
    Deposit: 'Deposit',
    None: 'None',
    Requested: 'Requested',
    Signed: 'Signed',
    SignFailed: 'Sign Failed',
    Submitted: 'Submitted',
    ExactGet: 'Exact Get',
    ExactPay: 'Exact Pay',
  },

  EnumOperationType: {
    Withdraw: 'Withdraw',
    Sweep: 'Sweep',
    Uniswap: 'Uniswap',
  },

  EnumTransactionStatus: {
    Rejected: 'Rejected',
    Failed: 'Failed',
    Pending: 'Pending',
    Approved: 'Approved',
    Completed: 'Completed',
  },

  accountSetting: {
    email: 'Login Email',
    timezone: 'Time Zone',
    language: 'Language',
    password: 'Password',
    changePassword: 'Change Password',

    creationTime: 'Creation Time',
    programName: 'Program Name',
    programDisplayName: 'Program Display Name',
    kycIdvMethod: 'IDV Method',
    questionType: 'Question Type',
    programCurrency: 'Program Currency',
    assignedTo: 'Assigned To',
    lastModifiedTime: 'Last Modified Time',
  },
  changePassword: {
    changePassword: 'Change Password',
    confirm: 'Confirm',
    cancel: 'Cancel',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    confirmPassword: 'Confirm New Password',
    changedSuccess: 'Password changed',
    passwordRequirements:
      'Password must contain 8-40 characters, at least 1 uppercase letter, at least 1 symbol, and at least 1 number',
    characterLimit: '8-40 characters',
    requiredUpperCase: 'At least 1 uppercase letter',
    requiredSymbol: 'At least 1 symbol',
    requiredNumber: 'At least 1 number',
  },

  login: {
    email: 'Email',
    password: 'Password',
    send: 'Send',
    resend: 'Resend',
    emailNotExistError: 'Email Address does not exist',
    programAgentId: 'Program Agent Id',
    enterEmail: {
      email: 'Email Address',
    },
    emailVerification: {
      verificationCode: 'Verification Code',
      enterVerificationCode: 'Enter Verification Code',
    },
    resetPassword: {
      successResetAlert: 'Successfully reset password',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      characterLimit: '8-40 characters',
      requiredUpperCase: 'At least 1 uppercase letter',
      requiredSymbol: 'At least 1 symbol',
      requiredNumber: 'At least 1 number',
    },
    enterPassword: {
      password: 'Password',
    },
    enterPasswordWithVerify: {
      trustDevice: 'Trust this device',
      verificationCodeCardTitle: 'Verifying Your Device',
      verificationCodeCardSubtitle: 'Click “Send” to send verification code to your email address',
    },
    forgotPassword: 'Forgot Password?',
    enterForgotPasswordEmail: {
      title: 'Forgot Password?',
      email: 'Email Address',
      enterVerifiedEmail: 'Please enter the registered email to receive email verification code',
      emailNotFound: 'Email Address does not exist',
    },
  },

  validation: {
    selectRequired: 'Please select {{fieldName}}',
    inputRequired: 'Please enter {{fieldName}}',
    shouldBeLargerThanZero: '{{fieldName}} must be larger than 0',
    requiredLength: '{{fieldName}} must be between {{min} to {{max} characters',
    requiredUpperCase: '{{fieldName}} must contain at least {{min} uppercase letter',
    requiredSymbol: 'Password must contain at least 1 symbol',
    requiredContainNumber: '{{fieldName}} must contain at least {{min}} number',
    confirmPassword: 'Password and Confirm Password must be the same',
    loginEmailInvalid: 'Invalid email address format',
  },

  component: {
    typeToSearch: 'Type to Search',
    noRecords: 'No relevant record exists',
    itemTotalStart: '',
    itemTotalEnd: ' item(s) in total',
    clickSearchToViewRecords: 'Click search to view records',
    startMonth: 'Start Month',
    endMonth: 'End Month',
  },

  transactionRequest: {
    operation: 'Operation',
    createdDate: 'Created Date',
    chain: 'Chain',
    assetName: 'Asset Name',
    id: 'ID',
    batchId: 'Batch ID',
    operationType: 'Operation Type',
    chainType: 'Chain Type',
    chainId: 'Chain ID',
    totalOperation: 'Total Operation',
    requestTime: 'Request Time',
    approvalRequired: 'Approval Required',
    status: 'Status',
    approvalCompleted: 'Approval Completed',
    createdBy: 'Created By',
    lastModifiedBy: 'Last Modified By',
    lastModifiedDate: 'Last Modified Date',
    transactionOperations: 'Transaction Operations',
    approvalProgress: 'Approval Progress',
    approval_sequence: 'Approval Sequence',
    permission: 'Permission',
    operation_result: 'Operation Result',
    operated_by: 'Operated By',
    operation_time: 'Operation Time',
    operationSequence: 'Operation Sequence',
    merchantOrderId: 'Merchant Order ID',
    version: 'Version',
    path: 'Path',
    walletTagOfReceivingAddress: 'Wallet Tag of Receiving Address',
    toAddress: 'To Address',
    maxPayAmount: 'Max Pay Amount',
    exactGetAmount: 'Exact Get Amount',
    swapPath: 'Swap Path',
    executionType: 'Execution Type',
    exactPayAmount: 'Exact Pay Amount',
    minGetAmount: 'Min Get Amount',
    swapDetails: 'Swap Details',
    operations: 'Operations',
    merchantNames: 'Merchant Names',
    merchantName: 'Merchant Name',
  },
};

export default json;
